type AllowedMetaName = 'description' | 'twitter:title' | 'description' | 'twitter:description' | 'twitter:card' | 'twitter:site' | 'twitter:creator' | 'twitter:image'
export const getHeadMetaName = ({ name, content }: { name: AllowedMetaName, content: string }) => ({ name, content })
